module.exports = __webpack_public_path__ + "img/loads-1.b31823d1.jpeg";